export const imageCodes = {
    about: {
        code: "${merchantId}_tmpl_img_29",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhomebg.jpg?alt=media&token=19e908bc-f5aa-4870-aec9-4e4695293125"
    },

    love: {
        code: "${merchantId}_tmpl_img_30",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flove.png?alt=media&token=1ce1f680-9292-43a6-9a9e-94297eb76b29"
    },

    love1: {
        code: "${merchantId}_tmpl_img_31",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flove1.png?alt=media&token=d433e84e-0c23-4a4e-8ac0-d705e1fa9de3"
    },

    love2: {
        code: "${merchantId}_tmpl_img_32",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flove2.png?alt=media&token=17c52902-d2d8-490b-9c0f-5d2c5b0212d4"
    },

    love3: {
        code: "${merchantId}_tmpl_img_33",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flove3.png?alt=media&token=4845f117-e1fd-46db-9b9f-c9b17acebf0c"
    },
    
    support: {
        code: "${merchantId}_tmpl_img_34",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Frec.png?alt=media&token=4e763b4b-d8a3-47e4-8856-5c7d8043f479"
    },
    
    support1: {
        code: "${merchantId}_tmpl_img_35",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Frec1.png?alt=media&token=0b41e848-1664-4076-9107-aa79c5e7bb7e"
    },
    
    support2: {
        code: "${merchantId}_tmpl_img_36",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Frec2.png?alt=media&token=b770908b-edc1-4400-9680-8f0ebe072dc3"
    },

    support3: {
        code: "${merchantId}_tmpl_img_37",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Frec3.png?alt=media&token=e1f87532-6e5f-4ea2-8d34-199dc55a4cff"
    },
}

export const titleCodes = {
    title6: {
        code: "${merchantId}_tmpl_title_6",
        title: "Love Notes ❤️ "
    },

    title7: {
        code: "${merchantId}_tmpl_title_7",
        title: "Local Supporter "
    },
}
//
export const textCodes = {
    aboutus: {
        code: "${merchantId}_tmpl_text_1",
        text: "About Her.&Co & Our Products"
    },

    aboutus1: {
        code: "${merchantId}_tmpl_text_2",
        text: "🤵‍♀️ Her.&Co ရဲ့ Admin က Fancy & Fine Jewellery တွေကို စိတ်ဝင်စားသူ တစ်ဦးဖြစ်ပြီး မိမိနည်းတူလူငယ် အမျိုးသမီးများ Trendy & Affordable Jewellery ကို Stylist ကျကျဝတ်စားနိုင်အောင် တစ်ထောင့်တစ်နေရာမှ ပံ့ပိုးပေးနိုင်ရန် ရည်ရွယ်၍ တစ်နိုင်တစ်ပိုင် တည်ထောင်ခဲ့ခြင်း ဖြစ်ပါတယ်"
    },

    aboutus2: {
        code: "${merchantId}_tmpl_text_3",
        text: "✨ Her.& Co ရဲ့ products များမှာ 50% ကတော့ Handmade ( Not Handcraft) ဖြစ်ပြီး ကျန် 50% ကိုတော့ Customer များ Boring မဖြစ်စေရန် ရည်ရွယ်ပြီး Korea Supplies မှ Trendy Products များပါ ထည့်သွင်း ရောင်းပေးပါတယ်ရှင်"
    },

    aboutus3: {
        code: "${merchantId}_tmpl_text_4",
        text: "💛 Her.& Co ဆိုတဲ့ နာမည်လေးအတိုင်း နောက်ပိုင်းမှာ မိန်းကလေး များနဲ့ဆိုင်သော Accessories များ Essential Items များကို ကြိုးစားထုတ်လုပ်သွားမှာ ဖြစ်ပါတယ်ရှင်"
    },

    aboutus4: {
        code: "${merchantId}_tmpl_text_5",
        text: "💌 Her.& Co ရဲ့ အမြတ်ငွေလေးများကို တစ်နိုင်တစ်ပိုင် လိုအပ်သော Donation လေးများမှာလည်းထည့်သွင်း လှူဒါန်းနေပါတယ်ရှင် အားလုံး ဘေးကင်း လုံခြုံပါစေရှင် 💗"
    },
}
export const videoCodes = {
    video1: {
        code: "${merchantId}_tmpl_video_1",
        video: "https://www.youtube.com/embed/Xbqd0mhRM2w"
    }
}